module.exports = __webpack_public_path__ + "static/assembla-de022a307b4a4185179caf4adc83e1e8.png";